import { useEffect } from 'react';
import { updateForm } from '../../../store/actions/userManagementAction';
import { applyFieldPatches } from './utility';
import {
  DESIGNATIONS_WITH_OPTIONAL_HPR,
  MPW_MPHW_DESIGNATION,
  USER_TYPE,
} from './constant';
import {
  getHprFieldModeConfig,
  getResetHprFieldPatch,
  getVerificationResultConfig,
} from './userRulesController';

export const useUserDetailsForm = ({
  dispatch,
  navItemsModal,
  setFormCompleted,
  formState1,
  setFormState1,
  setUserData,
  setfacilityFormData,
  setfieldFormData,
  clearHpr,
  isVerified,
  hfrAbhaId,
  faceAuthVerifiedMob,
  setAlertModalOpen,
}) => {
  const isFacilityLevelUser = formState1.user_type.value === USER_TYPE.FACILITY_LEVEL;
  const isFieldLevelUser = formState1.user_type.value === USER_TYPE.FIELD_LEVEL;
  const isMpwDesignation = formState1.designation.value === MPW_MPHW_DESIGNATION;
  const hasOptionalHprDesignation = DESIGNATIONS_WITH_OPTIONAL_HPR.includes(formState1.designation.value);

  const handleFormChange1 = (value, key, id, option, code) => {
    setFormCompleted(Array(navItemsModal.length).fill(false));
    if (key === 'abha_id') {
      dispatch(updateForm('hfr', value));
    }
    if (key === 'fName') {
      dispatch(updateForm('fName', value));
    }
    if (key === 'lName') {
      dispatch(updateForm('lName', value));
    } else if (key === 'hpr_id') {
      dispatch(updateForm('hfrAbha', value));
    }

    setFormState1((prevState) => ({
      ...prevState,
      [key]: {
        ...prevState[key],
        value,
        id,
        code,
        isError: false,
        message: '',
      },
    }));
  };

  useEffect(() => {
    if (clearHpr) {
      setFormState1((currentFormState) => applyFieldPatches(currentFormState, {
        hpr_id: {
          value: '',
        },
      }));
      dispatch(updateForm('hprNumberCheck', false));
      dispatch(updateForm('ishprEntered', false));
      dispatch(updateForm('isOkButtonClicked', true));
    }
  }, [clearHpr, dispatch, setFormState1]);

  useEffect(() => {
    const resetHprPatch = getResetHprFieldPatch();

    if (isFacilityLevelUser) {
      dispatch(updateForm('hfrAbha', ''));

      setfacilityFormData((currentFacilityFormData) => ({
        ...currentFacilityFormData,
        health_provider_tagged: {
          ...currentFacilityFormData.health_provider_tagged,
          '#isDisabled': true,
          '#options': [],
        },
        mobiliser_tagged: {
          ...currentFacilityFormData.mobiliser_tagged,
          '#isDisabled': false,
          '#options': [],
        },
      }));
    } else {
      dispatch(updateForm('hfrAbha', ''));
      setfieldFormData((currentFieldFormData) => ({
        ...currentFieldFormData,
        health_provider_tagged: {
          ...currentFieldFormData.health_provider_tagged,
          '#isDisabled': false,
          '#options': [],
        },
        mobiliser_tagged: {
          ...currentFieldFormData.mobiliser_tagged,
          '#isDisabled': true,
          '#options': [],
        },
      }));
      setUserData((prevState) => ({
        ...prevState,
        user_status: {
          ...prevState.user_status,
          '#isDisabled': false,
          '#required': true,
        },
      }));
      setFormState1((currentFormState) => applyFieldPatches(currentFormState, {
        user_status: {
          value: true,
        },
      }));
    }

    if (isFacilityLevelUser) {
      if (isMpwDesignation) {
        dispatch(updateForm('hfrAbha', ''));
        setUserData((prevState) => applyFieldPatches(prevState, getHprFieldModeConfig({ mode: 'abha-only' })));
        setFormState1((prevState) => applyFieldPatches(prevState, {
          ...resetHprPatch,
          user_status: { value: false },
        }));
      } else if (!hasOptionalHprDesignation) {
        dispatch(updateForm('hfrAbha', ''));
        setUserData((prevState) => applyFieldPatches(prevState, getHprFieldModeConfig({ mode: 'hpr-required' })));
        setFormState1((prevState) => applyFieldPatches(prevState, {
          ...resetHprPatch,
          user_status: { value: false },
        }));
      } else {
        dispatch(updateForm('hfrAbha', ''));
        dispatch(updateForm('designation', ''));
        setUserData((prevState) => applyFieldPatches(prevState, getHprFieldModeConfig({ mode: 'hpr-optional' })));
        setFormState1((prevState) => applyFieldPatches(prevState, {
          ...resetHprPatch,
          user_status: { value: true },
        }));
      }
    } else if (isFieldLevelUser) {
      dispatch(updateForm('hfrAbha', ''));
      setUserData((prevState) => applyFieldPatches(prevState, getHprFieldModeConfig({ mode: 'abha-only' })));
      setFormState1((prevState) => applyFieldPatches(prevState, {
        ...resetHprPatch,
        user_status: { value: false },
      }));
    } else {
      setUserData((prevState) => applyFieldPatches(prevState, getHprFieldModeConfig({ mode: 'default' })));
      setFormState1((prevState) => applyFieldPatches(prevState, resetHprPatch));
    }

    if (isFacilityLevelUser && isMpwDesignation) {
      dispatch(updateForm('userType', USER_TYPE.FACILITY_LEVEL));
      dispatch(updateForm('designation', MPW_MPHW_DESIGNATION));
      dispatch(updateForm('hfrAbha', ''));
    } else if (isFacilityLevelUser && !isMpwDesignation) {
      dispatch(updateForm('userType', USER_TYPE.FACILITY_LEVEL));
      dispatch(updateForm('hfrAbha', ''));
    } else if (isFieldLevelUser) {
      dispatch(updateForm('userType', USER_TYPE.FIELD_LEVEL));
      dispatch(updateForm('designation', formState1.designation.value));
      dispatch(updateForm('hfrAbha', ''));
    }

    if (!formState1.user_type.value) {
      dispatch(updateForm('userType', ''));
    }
    if (!formState1.designation.value) {
      dispatch(updateForm('designation', ''));
    }
  }, [
    dispatch,
    formState1.designation.value,
    formState1.user_type.value,
    hasOptionalHprDesignation,
    isFacilityLevelUser,
    isFieldLevelUser,
    isMpwDesignation,
    setFormState1,
    setUserData,
    setfacilityFormData,
    setfieldFormData,
  ]);

  useEffect(() => {
    const isAbhaFlow =
      formState1?.user_type?.value === USER_TYPE.FIELD_LEVEL ||
      (formState1?.user_type?.value === USER_TYPE.FACILITY_LEVEL && formState1.designation.value === MPW_MPHW_DESIGNATION);
    const isRelevantFlow =
      formState1?.user_type?.value === USER_TYPE.FIELD_LEVEL ||
      formState1?.user_type?.value === USER_TYPE.FACILITY_LEVEL;

    if (!isRelevantFlow) {
      return;
    }

    const { formStatePatch, userDataPatch, shouldAlert } = getVerificationResultConfig({
      isVerified,
      isAbhaFlow,
      hfrAbhaId,
    });

    setFormState1((currentFormState) => applyFieldPatches(currentFormState, formStatePatch));

    if (userDataPatch) {
      setUserData((currentUserData) => applyFieldPatches(currentUserData, userDataPatch));
    }

    if (shouldAlert) {
      setAlertModalOpen(true);
    }
  }, [formState1.designation.value, formState1.user_type.value, hfrAbhaId, isVerified, setAlertModalOpen, setFormState1, setUserData]);

  useEffect(() => {
    if (faceAuthVerifiedMob) {
      setFormState1((prev) => ({
        ...prev,
        mob: {
          ...prev.mob,
          value: faceAuthVerifiedMob,
        },
      }));
    }
  }, [faceAuthVerifiedMob, setFormState1]);

  return {
    handleFormChange1,
  };
};
